import React from 'react';
import { compose } from 'ramda';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import styleFile from '../style';
import LoyaltyPublic from './Public';
import LoyaltyInfo from './Info';
import {connect} from 'react-redux';


const FidelTourManagement = ({theme,  theme: { styles: { classes }}, loyaltyUser, customerForm }) => {
  return (
    <>
      {loyaltyUser && <div className={[theme.computedInnerStyle, customerForm ? classes.marginCustomerForm : ''].join(' ') }>
        <div className={classes.content}>
          <LoyaltyInfo infoUser={ loyaltyUser } customerForm={customerForm} />
        </div>
      </div>
      }
      {!loyaltyUser &&        
        <div className={[classes.content, customerForm ? classes.contentCustomerForm : ''].join(' ')}>
          <LoyaltyPublic customerForm={customerForm}/>
        </div>        
      }
    </>
  );

};

const mapStateToProps = (store) => {  
  return {
    loyaltyUser : store.getIn(['customer', 'loyalty', 'user','user_id'], null) && store.getIn(['customer', 'loyalty','user'], null)
  };
};

export default compose(connect(mapStateToProps), withThemeJSS({ styleFile, link: true }), withContent('i18n'))(FidelTourManagement);